import appGlobalScript from '/var/jenkins_home/workspace/arm-design-system-build_master/core/src/components/core/global/ads-global.ts';
export const globalScripts = appGlobalScript;
